// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendReferralPopup-module__modalContainer___y41T8 {
  overflow: visible;
}

.SendReferralPopup-module__content___x0JqA {
  padding: 25px 30px;
}

.SendReferralPopup-module__buttonsContainer___Abx6_ {
  gap: 16px;
  display: flex;
  padding: 30px;
  justify-content: end;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/popups/SendReferralPopup/SendReferralPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,2CAAA;AACF","sourcesContent":[".modalContainer {\n  overflow: visible;\n}\n\n.content {\n  padding: 25px 30px;\n}\n\n.buttonsContainer {\n  gap: 16px;\n  display: flex;\n  padding: 30px;\n  justify-content: end;\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `SendReferralPopup-module__modalContainer___y41T8`,
	"content": `SendReferralPopup-module__content___x0JqA`,
	"buttonsContainer": `SendReferralPopup-module__buttonsContainer___Abx6_`
};
module.exports = ___CSS_LOADER_EXPORT___;
